import classNames from "classnames"
import React, { useEffect, useState } from "react"
import LocationMap, { MapStyleConfig } from "./LocationMap"
import { GeocodedAddressType } from "~/components/Map/map-helpers"
import MapControl from "~/components/Map/MapControl"
import MapAutocomplete from "~/components/Map/MapAutoComplete"

type MapAddressProps = {
  showFunctionalities: boolean
  handleLocationData: (data: GeocodedAddressType) => void
  value?: any
  mapStyle: MapStyleConfig
  className?: string
  mapClassName?: string
  customMarker?: boolean
  children?: React.ReactNode
  footer?: React.ReactNode
  drawingMode?: any
  onPolyComplete?: any
}

const MapAddress = ({
  showFunctionalities,
  handleLocationData,
  value,
  mapStyle,
  className,
  mapClassName,
  customMarker,
  children,
  drawingMode,
  onPolyComplete,
  footer,
}: MapAddressProps) => {
  const [center, setCenter] = useState<any>(value)

  function handleMapChange(address: GeocodedAddressType) {
    if (!address) return
    setCenter(address.location.coordinates)
    handleLocationData(address)
  }

  useEffect(() => {
    if (value) {
      setCenter(value)
    }
  }, [value])

  return (
    <div className={classNames("h-full w-full", className)}>
      <LocationMap
        className={mapClassName}
        disabled={!showFunctionalities}
        onChange={handleMapChange}
        center={center}
        mapStyle={mapStyle}
        customMarker={customMarker}
        drawingMode={drawingMode}
        onPolyComplete={onPolyComplete}
      >
        {showFunctionalities ? (
          <MapControl position="TOP_CENTER">
            <MapAutocomplete onChange={handleMapChange} />
          </MapControl>
        ) : null}
        {children}
      </LocationMap>
      {footer}
    </div>
  )
}

export default MapAddress
